import React from 'react'
import { UserButton } from '@clerk/clerk-react'
import { Wallet } from 'lucide-react'
import { formatCurrency } from '@/lib/currency'

interface HeaderProps {
  title: string
  balance?: number
  currency?: string
}

export function Header({ title, balance, currency = 'PHP' }: HeaderProps) {
  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-sm border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>

        <div className="flex items-center gap-4">
          {balance !== undefined && (
            <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-indigo-50 rounded-lg">
              <Wallet className="h-4 w-4 text-indigo-500" />
              <span className="text-sm font-medium text-indigo-700">
                {formatCurrency(balance, currency)}
              </span>
            </div>
          )}

          <div className="lg:hidden">
            <UserButton
              afterSignOutUrl="/"
              appearance={{
                elements: {
                  avatarBox: 'h-8 w-8',
                },
              }}
            />
          </div>
        </div>
      </div>
    </header>
  )
}
